import React, { FC } from 'react'
import { Box } from '@moonpig/launchpad-components'
import { useExperimentBoolean } from '@moonpig/web-core-eppo/browser'
import { useProductStore } from '../../contexts/product'
import { ModuleContext, ModulePills } from '../types'
import { ProductPills, PrimaryPill } from '../../components/ProductPills'
import { isCardProduct } from '../../utils/isCardProduct'

type Props = {
  module: ModulePills
  context: ModuleContext
}

export const PillsModule: FC<Props> = ({ module: { show } }) => {
  const [{ product }] = useProductStore()

  const isCard = product.category && isCardProduct(product.category.department)

  const isFrictionlessFlowEnabled = useExperimentBoolean(
    'frictionless-flow-v1',
    {
      fallback: false,
    },
  )

  const ProductPillsComponent =
    isFrictionlessFlowEnabled && isCard && show === 'primary only'
      ? PrimaryPill
      : ProductPills

  const hasProductPills = Boolean(
    product.primaryProductPill || product.productPills?.length,
  )

  return hasProductPills ? (
    <Box data-testid="module-pills" mb={6}>
      <ProductPillsComponent
        primaryProductPill={product.primaryProductPill}
        productPills={product.productPills}
      />
    </Box>
  ) : null
}
